module.exports = __webpack_public_path__ + "img/golf_sub_title1.538a41ca.jpg";